import apiClient from './client'
import { FreetextSuggestion, ResolveFreetextInput } from '@/types/admin'

export const freetextApi = {
  /**
   * List freetext suggestions
   * @param resolved - Filter by resolution status (true = resolved, false = unresolved, undefined = all)
   */
  list: async (resolved?: boolean) => {
    const queryString = resolved !== undefined ? `?resolved=${resolved}` : ''
    const response = await apiClient.get<{ suggestions: FreetextSuggestion[] }>(
      `/admin/freetext/suggestions${queryString}`,
    )
    return response.suggestions
  },

  /**
   * Resolve a freetext suggestion by mapping to correct Wikidata entities
   * @param suggestionId - The ID of the suggestion to resolve
   * @param input - The correct Wikidata IDs for composer and/or work
   */
  resolve: async (suggestionId: string, input: ResolveFreetextInput) => {
    const response = await apiClient.post<{ message: string }>(
      `/admin/freetext/suggestions/${suggestionId}/resolve`,
      input,
    )
    return response
  },

  /**
   * De-duplicate freetext suggestions by updating duplicate with master's Wikidata IDs
   * @param masterId - The ID of the suggestion with canonical Wikidata IDs (source)
   * @param duplicateId - The ID of the suggestion to update (target)
   * @param mergeComposer - Whether to copy composer_wikidata_id (default: true)
   * @param mergeWork - Whether to copy work_wikidata_id (default: true)
   */
  merge: async (
    masterId: string,
    duplicateId: string,
    mergeComposer: boolean = true,
    mergeWork: boolean = true,
  ) => {
    const response = await apiClient.post<{ suggestion: FreetextSuggestion; message: string }>(
      `/admin/freetext/suggestions/merge`,
      {
        master_id: masterId,
        duplicate_id: duplicateId,
        merge_composer: mergeComposer,
        merge_work: mergeWork,
      },
    )
    return response
  },
}
